<template>
  <div>
   <div class="login_tit">
      <img src="../../assets/image/xf_vue_index.jpg" hight="100px" width="100px" alt="center">
   </div>
    <section style="padding: 30px 30px; display: flex; flex-flow: column nowrap;">
      <div style="font-size: 20px; font-weight: bold">告知承诺书</div>
      <!-- <div>验证码已通过短信发送至&nbsp;{{ tel }}</div> -->
      <div>
        <van-cell-group>
				 <div class="menu-wrap-title">报考人员应对网上提交的信息和材料负责，如个人填报信息失真、不符合报考条件和岗位要求，由此造成的一切后果，责任自负。</div>
				  <div class="checkbox-wrap">
				      <van-checkbox v-model="agreeChecked">同意</van-checkbox>
				  </div>	
        </van-cell-group>
        <span style="color: red" v-show="errMsg">{{ errMsg }}</span>
      </div>
      <div style="background-color: DarkGray">
        <van-button :type="type" block :disabled="subDisabled" @click="submitForm">下一步</van-button>
      </div>
    </section>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import {isCode,isPhone,IsCard} from '@/utils/commons'
  import {auth_data}  from "@/utils/auth";
  import { sendLoginCode, loginByCode } from "@/api";

  export default {
    name: "Confirm",
    components: {NavBar},
	watch: {
	      agreeChecked(val){
	          this.disabledChange();
	      },
	  },
    mounted(){
      this.$refs.code.focus()
    },
    data(){
      return{
        checkeds: false,
        agreeChecked:false,
        subDisabled:true,
		type : 'danger',
      }
    },
	methods: {
		  check() {
		  	console.log('点击了')
		  	this.checkeds = !this.checkeds
		  },
		  disabledChange(){
		      let that=this;
		      if(that.agreeChecked){
		          that.subDisabled=false;
		      }else{
		          that.subDisabled=true;
		      }
		  },
		  submitForm(){
		      let that=this;
			  this.$router.push('/registration');
		  }
	}
  }
</script>

<style scoped>
	.login_tit {
	  display: flex;
	  justify-content: center;
	  align-items: center;
	}
	.login_tit img{
	  width : 100%;
	}
  section div{
    margin-bottom: 10px;
  }
</style>
